import fetch from "auth/FetchMasterInterceptor";
const ProductionService = {};

ProductionService.stagesForProduction = function (reqeustParam) {
  return fetch({
    url: "/production-stage/stages-for-production",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.stageByCategory = function (reqeustParam) {
  return fetch({
    url: "/production-stage/stage-by-category",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.categoryStages = function (categoryId) {
  return ProductionService.stageByCategory({ category_id: categoryId });
};

//stage
ProductionService.getStage = function (reqeustParam) {
  return fetch({
    url: "/production-stage/list",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.addStage = function (reqeustParam) {
  return fetch({
    url: "/production-stage/add",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.updateStage = function (reqeustParam) {
  return fetch({
    url: "/production-stage/update",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.deleteStage = function (reqeustParam) {
  return fetch({
    url: "/production-stage/delete",
    method: "post",
    data: reqeustParam,
  });
};

//category stage
ProductionService.getcategoryStage = function (reqeustParam) {
  return fetch({
    url: "/production-stage/category-stage",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.getcategoryStageAdd = function (reqeustParam) {
  return fetch({
    url: "/production-stage/category-stage-add",
    method: "post",
    data: reqeustParam,
  });
};

//production
ProductionService.productionList = function (reqeustParam) {
  return fetch({
    url: "/production-stage/production-list",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.productionDetails = function (reqeustParam) {
  return fetch({
    url: "/production-stage/production-deatils",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.productionStore = function (reqeustParam) {
  return fetch({
    url: "/production-stage/production-store",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.productionDelete = function (reqeustParam) {
  return fetch({
    url: "/production-stage/production-delete",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.addOrderToProduction = function (reqeustParam) {
  return fetch({
    url: "/production-stage/order-production-store",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.productionStep = function (reqeustParam) {
  return fetch({
    url: "/production-stage/production-step",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.moveNextStep = function (reqeustParam) {
  return fetch({
    url: "/production-stage/move-to-next-step",
    method: "post",
    data: reqeustParam,
  });
};

//Area
ProductionService.getArea = function (reqeustParam) {
  return fetch({
    url: "/area/list",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.addArea = function (reqeustParam) {
  return fetch({
    url: "/area/add",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.updateArea = function (reqeustParam) {
  return fetch({
    url: "/area/update",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.deleteArea = function (reqeustParam) {
  return fetch({
    url: "/area/delete",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.addProductionProcess = function (reqeustParam) {
  return fetch({
    url: "/production-process/add-or-update",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.listProductionProcess = function (reqeustParam) {
  return fetch({
    url: "/production-process/list",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.productionProcessDetails = function (reqeustParam) {
  return fetch({
    url: "/production-process/details",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.deleteProductionProcess = function (reqeustParam) {
  return fetch({
    url: "/production-process/delete",
    method: "post",
    data: reqeustParam,
  });
};

ProductionService.addToProductionProcess = function (reqeustParam) {
  return fetch({
    url: "/production-process/add-to-process",
    method: "post",
    data: reqeustParam,
  });
};

export default ProductionService;
